import NewHeader_dev from "../components/NewHeader_dev";
import MainVanner_dev from "../components/MainVanner_dev";
import Footer from "../components/Footer";
import HomeCSS from "./Home_dev.module.css";
import Loader from "../components/Loader";
import React, {useState, useEffect} from 'react'

function Home_dev() {
  return (
    <div className={HomeCSS.base}>
      <div className={HomeCSS.ref}>
        {/* <img src="img/Home.png" alt="ex" /> */}
      </div>
      <div>
        <NewHeader_dev />
        <MainVanner_dev />        
      </div>   
      <br />
      <br />         
      <Footer />
    </div>
  );
}
export default Home_dev;
